import styled from 'styled-components'

import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.gray400};
  padding: 0 0 12px 0;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    margin-bottom: 0px;
  }
`

export const Title = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.semiBold};

  cursor: pointer;

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.large};
  }
`

export const Date = styled.div`
  font-size: ${theme.font.sizes.xsmall};
  color: ${theme.colors.gray400};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`

interface IMessageProps {
  isVisible: boolean
}

export const Message = styled.div<IMessageProps>`
  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.gray700};

  max-height: ${({ isVisible }) => (isVisible ? '400px' : '0')};
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`
